// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// import './util/rem'
import "lib-flexible";
import BaiduMap from "vue-baidu-map";
import axios from "axios";
import qs from "qs";
import echarts from "echarts";
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import VueCookies from 'vue-cookies'
Vue.use(VueCookies)
// import Vconsole from 'vconsole'
// const vConsole = new Vconsole()
// Vue.use(vConsole)
Vue.use(ElementUI)
Vue.use(VueAwesomeSwiper, /* { default global options } */)
// Vue.use(BaiduMap, {
//   ak: 'dMsO7buHzC48E2E5IVFuRvi6aag7x87F'
// })
Vue.prototype.$echarts = echarts;
let userId = localStorage.getItem("userId");
let uuidInfo = localStorage.getItem("uuid");
let userUuid = localStorage.getItem("userUuid");
let uuid = uuidInfo + userUuid
// axios.defaults.withCredentials = true;
axios.defaults.withCredentials = false;
axios.interceptors.request.use(
  config => {
    config.headers = {
      "content-type": "application/x-www-form-urlencoded",
      "uuid":uuid,
      'userId':userId?userId: ''
    };
    return config;
  },
  function(error) {
    return Promise.reject(error);
  }
);
// 添加响应拦截器
axios.interceptors.response.use(
  res => {
    // console.log('请求url', res.config.url)
    // console.log('请求data', res.data)
    if (res.data && res.data.status) {
      if (+res.data.status.code === 0) {
        return { success: true, ...res.data };
      } else {
        return { success: false, ...res.data };
      }
    } else {
      return { success: false, ...res.data };
    }
  },
  error => {
    // 请求错误时做些事
    return Promise.reject(error);
  }
);
axios.defaults.transformRequest = data => {
  if (typeof data === "object" && !data.append) {
    return qs.stringify(data);
  } else {
    return data;
  }
};
if (process.env.NODE_ENV=='production') {
  axios.defaults.baseURL = process.env.API_ROOT;  
}
Vue.prototype.$axios = axios;
Vue.config.productionTip = false;
Vue.prototype.addBuried = function(data) {
  let userId = localStorage.getItem("userId");
  let uuid = localStorage.getItem("uuid");
  axios
    .post("api/log/buried/", {
      uuid:uuid,
      userId: userId?userId: '',
      ...data
    })
    .then(res => {
      if (res.success) {
      }
    })
    .catch(err => {
      console.log(err);
    });
};
function getIsWxClient () {
  var ua = navigator.userAgent.toLowerCase();
  if (ua.match(/MicroMessenger/i) == "micromessenger") {
      return true;
  }
  return false;
};
Vue.prototype.isMiniProgram = function(callback) { //是否为小程序环境
  //是否在微信环境
  if (!getIsWxClient()) {
      callback(false);
  } else {
       //微信API获取当前运行环境
       wx.miniProgram.getEnv((res) => {
           if (res.miniprogram) {//小程序环境
               callback(true);
           } else {
               callback(false);
           }
      })
  }
}
//触底事件
Vue.prototype.onReachBottom = function(callback){
  window.addEventListener('scroll',() => {
    //变量scrollTop是滚动条滚动时，距离顶部的距离
    var scrollTop = document.documentElement.scrollTop||document.body.scrollTop;
    //变量windowHeight是可视区的高度
    var windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
    //变量scrollHeight是滚动条的总高度
    var scrollHeight = document.documentElement.scrollHeight||document.body.scrollHeight;
    //滚动条到底部的条件
    if(parseInt(scrollTop+windowHeight)==scrollHeight-1){
      callback();
    }  
  })
}
/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js